// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 146) return "static/chunks/146-a56ecfac0cccde03.js";
	if (chunkId === 7131) return "static/chunks/7131-176025500e5a6953.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"b766ef233d6cc968","8620":"6554b26e9577d398","8867":"bc9ad7ab1b62cd8b","8964":"e7c8a5a3686976bd","9057":"09d7b718f1f47cfa"}[chunkId] + ".js";
};